import { apiClient } from './apiClient';

const base = '/api/usage';

export const usageService = {
  // Track usage
  track: usageData => apiClient.post(`${base}/usage`, usageData),

  // Get usage statistics
  getStats: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return apiClient.get(`${base}/stats?${queryParams}`);
  },

  // Get usage history
  getHistory: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return apiClient.get(`${base}/history?${queryParams}`);
  },

  // Get current usage
  getCurrent: () => apiClient.get(`${base}/current`),

  // Reset usage
  reset: () => apiClient.post(`${base}/reset`, {}),
};

export default usageService;
